import React from 'react';
import { CheckCircle } from 'lucide-react';
import { tg } from '../../telegram';

interface SuccessViewProps {
  title: string;
  message: string;
  onDone: () => void;
}

export const SuccessView: React.FC<SuccessViewProps> = ({ title, message, onDone }) => {
  React.useEffect(() => {
    tg.haptic.success();
  }, []);

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '40px 20px', textAlign: 'center', background: 'var(--bg-surface-subtle)',
      borderRadius: 'var(--radius-lg)', marginTop: 20
    }}>
      <div style={{ color: 'var(--color-success)', marginBottom: 16 }}>
        <CheckCircle size={64} />
      </div>
      <h2 style={{ fontSize: 24, fontWeight: 800, color: 'var(--text-primary)', marginBottom: 8 }}>
        {title}
      </h2>
      <p style={{ fontSize: 14, color: 'var(--text-secondary)', marginBottom: 32, lineHeight: 1.5 }}>
        {message}
      </p>
      
      <button 
        onClick={onDone}
        className="btn btn-primary"
        style={{ minWidth: 200, minHeight: 50, fontSize: 16 }}
      >
        Về Trang Chủ
      </button>
    </div>
  );
};
